<template>
	<nav class="toolbar">
		<div class="inner-toolbar">
			<slot></slot>
		</div>
	</nav>
</template>

<script>

export default {
	name: 'Toolbar',
}
</script>

<style>
	.toolbar {
		padding: 0;
		padding-left: 10px;
		/*padding-bottom: 0;*/
		z-index: 40;
		min-height: 48px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		font-family: "Exo 2", sans-serif;

		margin: 0;
		position: fixed;
		top: 45px;
		left: 0;
		right: 0;
		transition: left 0.5s;
		z-index: 29;
		border-bottom: 1px solid lightgray;
		background-color: var(--background-light);
	}

	.inner-toolbar {
		position: relative;
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}

	.inner-toolbar a {
		display: flex;
		align-items: center;
	}

	.menu-visible .toolbar {
		left: 250px;
	}

	.menu-visible.menu-icons-only .toolbar {
		left: 70px;
	}

	.toolbar .btn-link {
		color: #455A64;
	}

	.toolbar h2 {
		display: inline-block;
		margin: 0;
		padding: 0;
		font-size: 16pt;
		margin-right: 20px;
		margin-left: 10px;
		font-weight: 800;
	}

	.toolbar .btn.btn-link {
		padding-top: 0;
		padding-bottom: 0;
		margin-bottom: 0;
	}

	.toolbar .btn-link:hover {
		text-decoration: none;
	}

	.toolbar .btn-link:hover h2 {
		text-decoration: underline;
	}

	.toolbar .controls {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		flex-wrap: wrap;
		align-items: center;
		flex-grow: 1;
	}

	.toolbar .btn {
		margin-right: 10px;
		text-transform: uppercase;
	}

	.toolbar .btn.btn-link {
		height: auto;
	}

	@media (max-width: 1199px) {
		.toolbar {
			margin-left: -15px;
			margin-right: -15px;
			margin-top: -25px;
			margin-bottom: 10px;
			position: static;
		}

		.main-area>.container-fluid {
			margin-top: 50px;
		}
	}

</style>
